export const CharactersTypes = {
    SET_CHARACTERS : 'SET_CHARACTERS_CHARS',
    UPDATE_CHARACTERS : 'UPDATE_CHARACTERS_CHARS',
    UPDATE_CHAR : 'UPDATE_CHAR_CHARS',
    REMOVE_CHAR : 'REMOVE_CHAR_CHARS',
    REMOVE_MULTI_CHAR : 'REMOVE_MULTI_CHAR_CHARS',
    SELECT_CHAR : 'SELECT_CHAR_CHARS',
    UPDATE_CHILDREN_CHAR : 'UPDATE_CHILDREN_CHAR_CHARS',
    UPDATE_TOKEN : 'UPDATE_TOKEN_CHARS',
    DELETE_TOKEN : 'DELETE_TOKEN_CHARS',
    SET_SHEET_TEMPLATE : 'SET_SHEET_TEMPLATE_CHARS',
    SET_SHEET_FORM_OPENED : 'SET_SHEET_FORM_OPENED_CHARS',
    SET_SHEET_VALUES : 'SET_SHEET_VALUES_CHARS',
    ADD_SHEET_SHORTCUT : 'ADD_SHEET_SHORTCUT_CHARS',
    REMOVE_SHEET_SHORTCUT : 'REMOVE_SHEET_SHORTCUT_CHARS',
    SET_OPENED_DETAIL : 'SET_OPENED_DETAIL_CHARS',
    SEEK_FOR_TOKEN : 'SEEK_FOR_TOKEN_CHARS',
    RESET : 'RESET',
};